/* eslint-disable react/jsx-no-undef */
import Footer from "../Footer/Footer";
import Navbar from "../Navbar/Navbar";
import "./style.css";
import icon1 from "../../assets/images/icon1.png";
import icon2 from "../../assets/images/icon2.png";
import icon3 from "../../assets/images/icon3.png";
import icrageeLogo from "../../assets/images/icragee.png";
import Marquee from "react-fast-marquee";
import publicationPartner from "../../assets/sponsors/publicationPartner.png";
import picture2 from "../../assets/sponsors/Picture2.png";
import picture3 from "../../assets/sponsors/brns.jpg";
import picture4 from "../../assets/sponsors/Picture4.png";
import picture5 from "../../assets/sponsors/Picture5.png";
import picture6 from "../../assets/sponsors/Picture6.png";
import picture7 from "../../assets/sponsors/Picture7.png";
import picture8 from "../../assets/sponsors/Picture8.jpg";
import picture9 from "../../assets/sponsors/Picture9.png";
import picture10 from "../../assets/sponsors/Picture10.jpg";
import picture11 from "../../assets/sponsors/Picture11.jpg";
import picture12 from "../../assets/sponsors/Picture12.png";

const Layout = ({ children }) => {
  const pdfUrl = `${process.env.PUBLIC_URL}/Brochure draft 230522024.pdf`;
  const pptxUrl = `${process.env.PUBLIC_URL}/Template_Presentation_8ICRAGEE.pptx`;

  const handleOpenPdfInNewTab = () => {
    window.open(pdfUrl, "_blank");
  };

  const sponsors = [
    {
      name: "Publication Partner",
      image: publicationPartner,
    },
    {
      name: "Gold Sponsor",
      image: picture2,
    },
    {
      name: "Silver Sponsor",
      image: picture3,
    },
    {
      name: "Gold Sponsor",
      image: picture4,
    },
    {
      name: "Other Sponsor",
      image: picture5,
    },
    {
      name: "Gold Sponsor",
      image: picture6,
    },
    {
      name: "Silver Sponsor",
      image: picture7,
    },
    {
      name: "Bronze Sponsor",
      image: picture8,
    },
    {
      name: "Bronze Sponsor",
      image: picture9,
    },
    {
      name: "Bronze Sponsor",
      image: picture10,
    },
    {
      name: "Other Sponsor",
      image: picture11,
    },
    {
      name: "Other Sponsor",
      image: picture12,
    },
  ];

  return (
    <div className="nav-image">
      <div className="flex md:mt-5 md:mx-5 md:flex-row flex-col w-full md:items-center justify-between p-4 items-center">
        <img
          src={icrageeLogo}
          className="h-36 w-44 filter brightness-150"
          alt=""
        />
        <div className="flex flex-col md:text-4xl text-2xl  min-w-screen ">
          <span className="pb-2 pr-5 font-bold text-white mx-4">
            8<sup>th</sup> International Conference On Recent Advances in
            Geotechnical Earthquake Engineering and Soil Dynamics (8ICRAGEE)
          </span>
          <span className="font-bold text-2xl text-white mx-4">
            December 11-14, 2024
          </span>
        </div>
      </div>
      <div className="flex">
        <div className="flex mt-10 mb-20 md:flex-row flex-col items-center w-full justify-center gap-12">
          <img src={icon1} className="h-36 w-36" alt="Icon 2" />
          <img src={icon2} className="h-36 w-36" alt="Icon 1" />
          <img src={icon3} className="h-36 w-36" alt="Icon 3" />
          <button
            className="p-4 border-orange-500 my-2 border-2 h-20 mx-20 w-64 text-orange-500 font-bold bg-white md:hidden"
            onClick={handleOpenPdfInNewTab}
          >
            Click to Download Brochure
          </button>
        </div>
        <div className="mt-20 -mr-16 hidden md:flex">
          <button
            className="p-4 border-orange-500 my-2 border-2 h-20 mx-20 w-64 text-orange-500 font-bold bg-white"
            onClick={handleOpenPdfInNewTab}
          >
            Click to Download Brochure
          </button>
        </div>
      </div>
      {/* Running Header */}

      <div className="sticky top-10 z-50 mb-8">
        <p className="bg-white text-center md:h-[24vh] justify-center md:text-2xl md:py-[3vh] text-black font-semibold hover:cursor-default">
          <Marquee pauseOnHover speed={90}>
            {sponsors.map((sponsor, index) => (
              <div
                key={index}
                className="flex flex-col justify-center items-center gap-4 mx-8"
              >
                <img
                  src={sponsor.image}
                  alt={sponsor.name}
                  className={`w-52 h-14 ${
                    sponsor.image === picture5 ||
                    sponsor.image === picture4 ||
                    sponsor.image === picture3
                      ? "w-28 h-28"
                      : ""
                  }`}
                />
                <p className="text-lg">{sponsor.name}</p>
              </div>
            ))}
          </Marquee>
        </p>
      </div>

      <div className="sticky top-10 z-50">
        <p className="bg-white text-center md:h-[11vh] justify-center md:text-2xl md:py-[3vh] text-orange-500 font-bold hover:cursor-default">
          <Marquee pauseOnHover speed={90}>
            <p>
              You can download the presentation template from{" "}
              <a
                href={pptxUrl}
                download="presentation-template.pptx"
                className="underline-offset-1 underline text-blue-800"
              >
                here
              </a>
              .
            </p>
          </Marquee>
        </p>
      </div>
      <Navbar />
      <div className="bar mt-12">
        <span className="bar_content"></span>
      </div>
      <div className="pt-[15vw]">{children}</div>
      <Footer />
    </div>
  );
};

export default Layout;
